window.initMap = function () {
  'use strict';
  initMapDistribution();
  initSearchPlaceMap();
}
